import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=67e98b5a&"
import script from "./Authenticate.vue?vue&type=script&lang=ts&"
export * from "./Authenticate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports